import { createAction, props } from '@ngrx/store';

import { ProductViewPlace } from '../../../components/product-view/models/product-view-template.model';
import { ProductUid, RelatedProductMapItem } from '../../domain/models/related-products.models';

import { RelatedProductsCarousel, SetRelatedsCarouselsForPlaceSuccessProps } from './related-products.state';

import { CartItem } from '@api/cart/cart.models';
import { ProductPublicModels } from '@features/products/product';
import { EventFrom } from '@shared/analytics/COMMON/models/analytics-common.models';

export const RelatedProductsActionTypes = {
    SET_RELATEDS_CAROUSELS_FOR_PLACE: '[related-products] SET_RELATEDS_CAROUSELS_FOR_PLACE',
    SET_RELATEDS_CAROUSELS_FOR_PLACE_SUCCESS: '[related-products] SET_RELATEDS_CAROUSELS_FOR_PLACE_SUCCESS',
    SET_RELATEDS_CAROUSELS_FOR_PLACE_ERROR: '[related-products] SET_RELATEDS_CAROUSELS_FOR_PLACE_ERROR',
    SET_RELATEDS_CAROUSELS_PRODUCTS_IDS_SUCCESS: '[related-products] SET_RELATEDS_CAROUSELS_PRODUCTS_IDS_SUCCESS',
    SET_RELATEDS_CAROUSELS_PRODUCTS_IDS_ERROR: '[related-products] SET_RELATEDS_CAROUSELS_PRODUCTS_IDS_ERROR',
    LOAD_RELATEDS_CAROUSELS_PRODUCTS: '[related-products] LOAD_RELATEDS_CAROUSELS_PRODUCTS',
    LOAD_RELATEDS_CAROUSELS_PRODUCTS_SUCCESS: '[related-products] LOAD_RELATEDS_CAROUSELS_PRODUCTS_SUCCESS',
    LOAD_RELATEDS_CAROUSELS_PRODUCTS_ERROR: '[related-products] LOAD_RELATEDS_CAROUSELS_PRODUCTS_ERROR',
    SET_RELATED_PRODUCT_VIEWED: '[related-products] SET_RELATED_PRODUCT_VIEWED',
    PRODUCT_VIEWED: '[related-products] PRODUCT_VIEWED',
};

export const SetRelatedsCarouselsForPlace = createAction(
    RelatedProductsActionTypes.SET_RELATEDS_CAROUSELS_FOR_PLACE,
    props<{
        placeName: ProductViewPlace;
        baseProducts: Array<ProductPublicModels.PublicProduct | CartItem>;
        section: string;
    }>(),
);

export const SetRelatedsCarouselsForPlaceSuccess = createAction(
    RelatedProductsActionTypes.SET_RELATEDS_CAROUSELS_FOR_PLACE_SUCCESS,
    props<SetRelatedsCarouselsForPlaceSuccessProps>(),
);

export const SetRelatedsCarouselsForPlaceError = createAction(
    RelatedProductsActionTypes.SET_RELATEDS_CAROUSELS_FOR_PLACE_ERROR,
);

export const SetRelatedsCarouselsProductsIdsSuccess = createAction(
    RelatedProductsActionTypes.SET_RELATEDS_CAROUSELS_PRODUCTS_IDS_SUCCESS,
    props<{
        placeName: ProductViewPlace;
        carousels: Record<string, Partial<RelatedProductsCarousel>>;
        excludedProducts: ProductPublicModels.PublicProduct[];
    }>(),
);

export const SetRelatedsCarouselsProductsIdsError = createAction(
    RelatedProductsActionTypes.SET_RELATEDS_CAROUSELS_PRODUCTS_IDS_ERROR,
    props<{ placeName: ProductViewPlace }>(),
);

export const LoadRelatedCarouselProducts = createAction(
    RelatedProductsActionTypes.LOAD_RELATEDS_CAROUSELS_PRODUCTS,
    props<{
        placeName: ProductViewPlace;
        carousel: Partial<RelatedProductsCarousel>;
        page: number;
    }>(),
);

export const LoadRelatedCarouselProductsSuccess = createAction(
    RelatedProductsActionTypes.LOAD_RELATEDS_CAROUSELS_PRODUCTS_SUCCESS,
    props<{
        placeName: ProductViewPlace;
        carousel: Partial<RelatedProductsCarousel>;
        page: number;
        productsMap: Record<string, RelatedProductMapItem>;
        filteredItemsIds?: ProductUid[];
    }>(),
);

export const LoadRelatedCarouselProductsError = createAction(
    RelatedProductsActionTypes.LOAD_RELATEDS_CAROUSELS_PRODUCTS_ERROR,
    props<{ placeName: ProductViewPlace; carousel: Partial<RelatedProductsCarousel>; page: number }>(),
);

export const SetRelatedProductViewed = createAction(
    RelatedProductsActionTypes.SET_RELATED_PRODUCT_VIEWED,
    props<{ placeName: ProductViewPlace; carousel: Partial<RelatedProductsCarousel> }>(),
);

export const ProductViewed = createAction(
    RelatedProductsActionTypes.PRODUCT_VIEWED,
    props<{
        product: ProductPublicModels.PublicProduct;
        eventFrom?: EventFrom;
        placeName?: ProductViewPlace;
        location?: string;
    }>(),
);
